<template>
<div class="container text-center">
    <img :src="fields.logo" class="logo" v-if="fields.logo" />
 <div class="body">
  <!--
  <div class="row p-4 m-4">
    <div class="col-2 mx-auto my-auto">
      <hr>
    </div>
    <div class="col-8 title mx-auto my-auto">
      <h1>{{ $prismic.richTextAsPlain(fields.title) }}</h1>
    </div>
    <div class="col-2 mx-auto my-auto">
      <hr>
    </div>
  </div>
  -->
  <!-- <div class="row m-3 pb-4">
    <div class="col">
      <img :src="fields.company_logos" class="company-logos" v-if="fields.company_logos" />
    </div>
  </div>
  -->
 </div>
</div>
</template>

<script>
export default {
  name: 'header-component',
  data () {
    return {
      fields: {
        title: null,
        logo: null,
        company_logos: null
      }
    }
  },
  methods: {
    fetchPrismicContent () {
      this.$prismic.client.getSingle('component-header')
        .then((document) => {
          this.fields.logo = document.data.logo.url
          this.fields.title = document.data.title
          this.fields.company_logos = document.data.company_logos.url
        })
    }
  },
  created () {
    this.fetchPrismicContent()
  }
}
</script>

<style scoped>
  .container {
      margin-bottom: 10%;
  }

  .logo {
      width: 250px;
      margin-top: -120px;
  }

  .body {
    background-color: #000;
    opacity: 0.7;
    color: #fff;
    border-radius: 5px;
  }

  .title h1 {
    font-size: 2rem;
  }

  .company-logos {
    width: 90%;
  }

  hr {
    border-top: 2px dotted #4D709C;
    height: 0;
  }
</style>
